export default "__VITE_ASSET__Di0Fvh5m__"